<script>

export default {
    methods: {
      async searchUnitMetrics(unitId, querystring) {
        try {
          let p = {};
          for (let k in querystring) {
            if (querystring[k]) { p[k] = querystring[k]; }
          }
          const response = await this.$api.get(`units/${unitId}/unit-metrics/?${new URLSearchParams(p).toString()}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting unit metrics');
          return null;
        }
      }
    }
};
</script>
